export const changeStreet = 'CHANGE_STREET';
export const changeHouse = 'CHANGE_HOUSE';
